var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Form',{attrs:{"title":`Alterar ${_vm.title}`,"type":_vm.id,"types":_vm.types,"fields":_vm.fields},on:{"submit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }